import { render } from "./TopPage.vue?vue&type=template&id=db3b6802"
import script from "./TopPage.vue?vue&type=script&lang=js"
export * from "./TopPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__